import { BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON } from 'mk/autogenerated/translations/ContactSeller.7387edc72ca24b3f9c2434e325f50296'
import { canOrderInBazaar, isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import type { MessageFormData } from 'mk2/apps/bazaar/components/MessageForm';
import { CATEGORIES_WITH_ORDER } from 'mk2/apps/bazaar/constants';
import { ContactSellerForAnonymous } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerForAnonymous';
import { ContactSellerForBuyer } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerForBuyer';
import { ContactSellerForSeller } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerForSeller';
import { BazaarMessageEntity, BazaarOrderEntity, BuyerEntity, ProductEntity, ProductQuality } from 'mk2/apps/bazaar/schemas';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Plan, UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ContactSeller.mscss';

interface OwnProps {
    className?: string;
    product: ProductEntity;
    buyers: BuyerEntity[];
    messages: BazaarMessageEntity[];
    bazaarOrders: BazaarOrderEntity[];
    sellerPhone?: string;

    requestUser: UserEntity;
    requestUserPermissions: string[];
    initiallyOpened?: boolean;
    isLoadingProductDetails?: boolean;

    onSendMessage(productId: number, productSlug: string, values: MessageFormData);
    onScrollToMessages(event: React.MouseEvent<HTMLAnchorElement>);
}

export const ContactSeller: React.FunctionComponent<OwnProps> = React.memo(({
    className,
    product, buyers, messages, bazaarOrders,
    requestUser,
    requestUserPermissions,
    initiallyOpened = false,
    isLoadingProductDetails = false,
    onSendMessage,
    onScrollToMessages,
    sellerPhone,
}) => {
    const isSeller = isAuthenticatedAs(requestUser, product.seller?.user);
    const isAnonymous = !isAuthenticated(requestUser);

    const category = product.properties.find((p) => p[0] === 'cat')[1];
    const canOrder = (
        canOrderInBazaar(requestUser, requestUserPermissions) &&
        !!category && CATEGORIES_WITH_ORDER.includes(category.toLowerCase())
    );

    // nachystane, ked sa v buducnosti nebude dat komunikovat bez urobenia objednavky
    const canSendMsg = true;

    sellerPhone = product.seller?.showSellerPhone
        ? sellerPhone
        : null;
    const eshopUrl = product.seller?.user.activePlan === Plan.PRO
        ? product.eshopUrl
        : null;

    if (isAnonymous) {
        return (
            <ContactSellerForAnonymous
                product={product}
                canOrder={canOrder}
                canSendMsg={canSendMsg}
                sellerPhone={sellerPhone}
                eshopUrl={eshopUrl}
            />
        );
    } else if (isLoadingProductDetails) {
        return (
            <div className={styles.ContactSeller__loadingBtnWrapper}>
                <Btn
                    type={BtnType.Blue}
                    label={BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON}
                    hasSpinner
                />
            </div>
        );
    } else if (isSeller) {
        return (
            <ContactSellerForSeller
                product={product}
                sellerPhone={sellerPhone}
                eshopUrl={eshopUrl}
            />
        );
    } else { // isBuyer (or pontential buyer)
        const myBuyer = buyers.find((b) => isAuthenticatedAs(requestUser, b.user));
        const buyerMessages = myBuyer ? messages.filter((m) => m.buyer.id === myBuyer.id) : [];
        const buyerOrders = myBuyer ? bazaarOrders.filter((bo) => bo.buyerUser.id === myBuyer.user.id) : [];

        return (
            <ContactSellerForBuyer
                product={product}
                canOrder={canOrder}
                canSendMsg={canSendMsg}
                sellerPhone={sellerPhone}
                eshopUrl={eshopUrl}
                buyerUser={requestUser}
                buyerMessages={buyerMessages}
                buyerOrders={buyerOrders}
                onSendMessage={onSendMessage}
                onScrollToMessages={onScrollToMessages}
                hasMessageFormInitiallyOpen={initiallyOpened}
            />
        );
    }
});
